import {
	autoinject,
	BindingEngine,
	customElement,
	PLATFORM,
} from 'aurelia-framework';

import { Field } from '~/components/field/common/field';
import { Form } from '~/components/form/form';
import {
	baseFieldProperties,
	registerComponent,
} from '~/forms/customisation-editor/property-meta';

const componentTagName = 'a-blank';

registerComponent(componentTagName, {
	name: 'Blank',
	requirePath: PLATFORM.moduleName('components/field/common/blank'),
	props: baseFieldProperties,
	isSelectable: true,
});

@autoinject
@customElement(componentTagName)
export class Blank {}
